import s from "./BlogSearch.module.scss";
import { NotFound } from "components/shared/NotFound";
import { InputSearch } from "components/form/InputSearch";
import cn from "classnames";

type BlogSearchProps = {
  search: string;
  count: number;
  handleSearch: (value: string) => void;
  isNotFound: boolean;
  className?: string;
};

export const BlogSearch = ({ search, count, handleSearch, isNotFound, className }: BlogSearchProps) => {
  return (
    <div className={cn(s.wrapper, className)}>
      <InputSearch
        type="secondary"
        searchTerm={search}
        handleSearch={handleSearch}
        placeholder="I'm searching for..."
      />
      <div className={s.count}>
        All articles: <span>{count}</span>
      </div>
      {isNotFound && <NotFound query={search} className={s.notFound} contentClassName={s.notFoundContent} />}
    </div>
  );
};
